import { Injectable } from '@angular/core';
import { HelpersService } from 'apps/mu-private-area/src/app/services/helpers.service';
import { environment } from '../../environments/environment';
import { getUserJWTResponse, ScreenSetBasicOptions } from './authentication.models';
import { Observable } from 'rxjs';

declare const gigya: any;

@Injectable({
  providedIn: 'root',
})
export class GigyaService {
  private source = '';
  private language = 'it';
  private _isSDKReady = false;

  constructor(private helpersService: HelpersService) {}

  public async loadSDK() {
    this.appendScript();
    return this.waitForGigya();
  }

  public appendScript() {
    if (!this.helpersService.isBrowser || document.getElementById('gigya-sdk')) return;
    const apiKey = environment.apiKeySAP;
    const script = document.createElement('script');
    script.id = 'gigya-sdk';
    script.type = 'text/javascript';
    script.src = `https://cdns.eu1.gigya.com/js/gigya.js?apikey=${apiKey}`;
    document.body.appendChild(script);
  }

  public waitForGigya(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.helpersService.isBrowser) {
        resolve(false);
      }

      const checkInterval = setInterval(() => {
        if (typeof gigya !== 'undefined') {
          clearInterval(checkInterval);
          this.isSDKReady = true;
          resolve(true);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        reject(new Error("Gigya non disponibile entro il timeout"));
      }, 5000);
    });
  }

  showScreenSet(componentOptions: ScreenSetBasicOptions) {
    if (this.helpersService.isBrowser) {
      this.source = `${location.protocol}//${location.host}`;
    }

    const options = {
      lang: this.language,
      regSource: this.source
    };
    Object.assign(options, componentOptions);

    gigya.accounts.showScreenSet(options);
  }

  registerHandlers(callBacks: Record<string,(res: any)=>void>) {
    gigya.accounts.addEventHandlers(callBacks);
  }

  get isSDKReady() {
    return this._isSDKReady;
  }

  set isSDKReady(val: boolean) {
    this._isSDKReady = val;
  }

  getAccountInfo(): Observable<any> {
    return new Observable((observer) => {
      gigya.accounts.getAccountInfo({
        callback: (response: any) => {
          if (response.errorCode === 0) {
            observer.next(response);
            observer.complete();
          } else {
            observer.error(response);
          }
        }
      });
    });
  }

  async getUserJWT(): Promise<getUserJWTResponse> {
    return new Promise((resolve, reject) => {
      if (typeof gigya !== 'undefined') {
        gigya.accounts.getJWT({
          fields: 'customIdentifiers, identities-active, emails, data',
          expiration: 86400,
          callback: (res: any) => {
            if (res.errorCode === 0) {
              this.helpersService.saveAccessToken(res.id_token);
              resolve({
                success: true,
                token: res.id_token
              });
            } else {
              reject({
                success: false,
                message: res.errorMessage
              });
            }
          },
        });
      } else {
        reject(
          {
            success: false,
            message: 'SDK not loaded.'
          }
        );
      }
    });
  }

  async setGigyaSessionCookie(cookie: { cookieName: string, cookieValue: string}) {
    if (!this.helpersService.isBrowser || !this.isSDKReady) return;
    document.cookie = `${cookie.cookieName}=${cookie.cookieValue}`;
    return new Promise((resolve, reject) => {
      gigya.socialize.refreshUI({
        callback: (res:any) => {
          if (res.errorCode === 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }
      });
    })
  }
}
